import React from 'react';
import { BarChart2, Clock, CheckCircle, XCircle, Archive } from 'lucide-react';

interface CertificateStats {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
  archived: number;
  averageScore: number;
}

interface CertificateStatsProps {
  stats: CertificateStats;
}

export function CertificateStats({ stats }: CertificateStatsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Total</div>
          <BarChart2 className="h-5 w-5 text-gray-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.total}</div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Pendentes</div>
          <Clock className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.pending}</div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Aprovados</div>
          <CheckCircle className="h-5 w-5 text-green-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.approved}</div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Reprovados</div>
          <XCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.rejected}</div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Arquivados</div>
          <Archive className="h-5 w-5 text-gray-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">{stats.archived}</div>
      </div>

      <div className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="text-sm font-medium text-gray-500">Média Geral</div>
          <BarChart2 className="h-5 w-5 text-blue-400" />
        </div>
        <div className="mt-2 text-3xl font-semibold text-gray-900">
          {stats.averageScore.toFixed(1)}%
        </div>
      </div>
    </div>
  );
}